
import { defineComponent } from "vue";
import { loadUPP_summary } from "@/api/upp";
import StatCard from "@/components/dashboard/sequence/StatCard.vue";

export default defineComponent({
  name: "upphistory",
  methods: {
    async getThisMonthAndYear() {
      var d = new Date();
      var m = d.getMonth();
      var y = d.getFullYear();
      this.month = m + 1;
      this.year = y;
    },
    async loadUPPSummary() {
      this.loading = true;
      this.totalcom = parseFloat("0.00");
      var params = {
        month: this.month,
        year: this.year
      };
      const response = await loadUPP_summary(params);
      console.log(response);
      this.list = response.data.pageList;
      this.list2 = response.data.pageList2;
      response.data.pageList2.forEach(element => {
        this.totalcom = this.totalcom + parseFloat(element.total);
      });
      this.loading = false;
    }
  },
  mounted() {
    this.getThisMonthAndYear();
    this.loadUPPSummary();
  },
  data() {
    return {
      month: 0,
      year: 0,
      list: [],
      list2: [],
      totalcom: 0.00,
      loading: true
    };
  },
  components: {
    StatCard
  },
  props: {
    widgetClasses: String
  }
});
